module.exports = __webpack_public_path__ + "static/media/2022.575a0775.png";